<template>
  <div style="max-height: 100px">
    <b-modal id="modalCategoriaConta" centered hide-header>
      <template #modal-footer>
        <div style="width: 100%; display: flex; justify-content: space-between">
          <button
            class="btnsModal"
            variant="info"
            size="sm"
            @click="handleCloseModalAndClear"
          >
            Fechar
          </button>
          <button
            class="btnsModal btnSave"
            variant="info"
            size="sm"
            @click="saveOrUpdate"
          >
            Salvar
          </button>
        </div>
      </template>
      <div class="mt-3">
        <div class="titleCard">
          <p>Categoria</p>
        </div>
        <div>
          <label style="font-size: 14px; color: #666360">
            Informe abaixo o nome da categoria
          </label>
          <div>
            <Input
              type="text"
              :dataInput.sync="dataCategoryBill.nome"
              ref="categoryBillName"
            />
          </div>
        </div>

        <table class="table table-sm mt-5">
          <thead>
            <tr style="width: 100%">
              <th style="width: 50%; font-size: 14px; font-weight: 600">
                Nome
              </th>
              <th
                style="
                  width: 50%;
                  text-align: center;
                  font-size: 14px;
                  font-weight: 600;
                  padding: 0 10px;
                "
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="receiptBill in dataAllCategoryBill"
              :key="receiptBill.id"
            >
              <td style="font-size: 14px">{{ receiptBill.nome }}</td>
              <td
                style="
                  text-align: center;
                  padding: 0 !important;
                  display: flex;
                  height: 100%;
                  justify-content: center;
                  gap: 20px;
                  padding: 0.5rem;
                "
              >
                <b-icon-pencil
                  @click="getCategoryBillFindById(receiptBill.id)"
                  scale="1"
                  role="button"
                />

                <b-icon-x-circle
                  @click="deleteCategoryBill(receiptBill.id)"
                  role="button"
                  style="color: red"
                  scale="1"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ServiceCategoryBill from "../../services/serviceCategoryBill";
import Input from "../UI/CustomInputs/Input.vue";

export default {
  data() {
    return {
      dataCategoryBill: {
        id: "",
        nome: "",
      },
      dataAllCategoryBill: [],
      tabIndexSected: 1,
      getCategoryBill: false,
    };
  },
  components: {
    Input,
  },
  methods: {
    async saveCategoryBill() {
      try {
        await ServiceCategoryBill.save(this.dataCategoryBill);
        this.getAllCategoryBill();

        this.$emit("getNewCategoryBill", this.getCategoryBill);
        this.getCategoryBill = !this.getCategoryBill;

        return this.$toast.open({
          message: "Salvo com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.erros}` || "Ocorreu um erro o salvar!",
          type: "info",
        });
      }
    },

    async updateCategoryBill() {
      await ServiceCategoryBill.update(this.dataCategoryBill);
      this.getAllCategoryBill();

      this.$emit("getNewCategoryBill", this.getCategoryBill);
      this.getCategoryBill = !this.getCategoryBill;

      return this.$toast.open({
        message: "Atualizado com sucesso!",
        type: "success",
      });
    },

    async deleteCategoryBill(idCategoryBill) {
      try {
        await ServiceCategoryBill.delete(idCategoryBill);
        this.getAllCategoryBill();

        this.$emit("getNewCategoryBill", this.getCategoryBill);
        this.getCategoryBill = !this.getCategoryBill;

        return this.$toast.open({
          message: "deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.log(error);
      }
    },

    async getCategoryBillFindById(idCategoryBill) {
      const result = await ServiceCategoryBill.findById(idCategoryBill);
      Object.assign(this.dataCategoryBill, result);
      this.$refs.categoryBillName.valueInput = result.nome;
      this.tabIndexSected = 0;
    },

    async getAllCategoryBill() {
      const result = await ServiceCategoryBill.fillComobobox();
      this.dataAllCategoryBill = result;
    },

    async saveOrUpdate() {
      this.dataCategoryBill.id === ""
        ? await this.saveCategoryBill()
        : await this.updateCategoryBill();
      this.clear();
    },

    clear() {
      this.dataCategoryBill.id = "";
      this.dataCategoryBill.nome = "";
      this.$refs.categoryBillName.valueInput = "";
    },

    handleCloseModalAndClear() {
      this.clear();
      this.$bvModal.hide("modalCategoriaConta");
    },
  },
  mounted() {
    this.getAllCategoryBill();
  },
};
</script>

<style scoped>
.styleHoverDelete:hover {
  background-color: #ff6347;
  border: solid 1px black;
}

.tabsContentSearch {
  overflow-y: scroll;
  max-height: 300px;
}

.btnsModal {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  height: 28px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.btnSave {
  background-color: transparent;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.titleCard {
  margin-bottom: 32px !important;
  font-weight: 600;
  color: #666360;
  font-size: 16px;
}
</style>